/**
 * Notifications selectors
 */
const selectNotifications = state => state.notifications;

export { selectNotifications };
